import { FlexContainerProps } from './types';
import React from 'react';
import { StyledFlexContainer } from './FlexContainer.styles';

const FlexContainer: React.FC<FlexContainerProps> = ({
	children,
	alignItems,
	flexDirection,
	justifyContent,
	gap,
	margin,
	width,
	minWidth,
	flexWrap,
	padding,
	className,
	height,
	id,
	backgroundColor,
	borderRadius,
	boxSizing,
	marginRight,
	marginBottom,
	marginTop,
	flex,
}) => (
	<StyledFlexContainer
		alignItems={alignItems}
		flexDirection={flexDirection}
		justifyContent={justifyContent}
		gap={gap}
		margin={margin}
		width={width}
		minWidth={minWidth}
		flexWrap={flexWrap}
		padding={padding}
		className={className}
		height={height}
		id={id}
		backgroundColor={backgroundColor}
		borderRadius={borderRadius}
		boxSizing={boxSizing}
		marginRight={marginRight}
		marginBottom={marginBottom}
		marginTop={marginTop}
		flex={flex}
	>
		{children}
	</StyledFlexContainer>
);

export { FlexContainer };
export default FlexContainer;
